export default "__VITE_ASSET__DkeMH5mx__"